module.exports = __webpack_public_path__ + "img/header-icon.035618ea.png";